import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Typography from '@mui/material/Typography';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Rating from '@mui/material/Rating';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { SliderComponent } from '../../../Component/Component';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const images = [
    {
      label: 'San Francisco – Oakland Bay Bridge, United States',
      imgPath:
        'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
    },
    {
      label: 'Bird',
      imgPath:
        'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
    },
    {
      label: 'Bali, Indonesia',
      imgPath:
        'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
    },
    {
      label: 'Goč, Serbia',
      imgPath:
        'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
    },
  ];
const ReviewSlider1 = () => {
    const theme = useTheme();
    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = images.length;
  
    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
  
    const handleBack = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
  
    const handleStepChange = (step) => {
      setActiveStep(step);
    };
  
    return (
        <SliderComponent
          square
          elevation={0}
        //   sx={{
        //     display: 'flex',
        //     flexDirection:'row'
        //     // alignItems: 'center',
        //     // height: 50,
        //   }}
        >
         <Grid container>
            <Grid item sm={12} xs={12} md={5} lg={5} xl={5}>
            <AutoPlaySwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <Box key={step.label}>
              {Math.abs(activeStep - index) <= 2 ? (
                <Box
                  component="img"
                  sx={{
                    height: '400px',
                    display: 'block',
                    maxWidth: 400,
                    overflow: 'hidden',
                    width: '100%',
                  }}
                  src={step.imgPath}
                  alt={step.label}
                />
              ) : null}
            </Box>
          ))}
        </AutoPlaySwipeableViews>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} xl={7} sx={{padding:'4%',display:'flex',flexDirection:'column'}}>
            <Typography variant='caption' sx={{color:'gray'}}>The Next War</Typography>
            <Typography>{images[activeStep].label}</Typography>
            <List>
                <ListItem>
                    <ListItemIcon>
                    <Stack direction="row">
                        <Avatar alt="Remy Sharp" src={images[activeStep].imgPath} />
                    </Stack>
                    </ListItemIcon>
                    <ListItemText>
                        <Typography variant="caption">0xe46...9575</Typography>
                        <Stack spacing={1}>
                            <Rating name="half-rating-read" defaultValue={2.5} precision={0.5} readOnly />
                            </Stack>
                    </ListItemText>
                </ListItem>
            </List>
            <Box sx={{display:'flex',flexDirection:'row'}}>
                    <ThumbUpAltOutlinedIcon sx={{padding:'5px',cursor:'pointer'}} />
                    <ThumbDownOutlinedIcon sx={{padding:'5px',cursor:'pointer'}}/>
                    <ChatBubbleOutlineOutlinedIcon sx={{padding:'5px',cursor:'pointer'}}/>
            </Box>
            <Box sx={{marginTop:'20%'}}>
                <List sx={{display:'flex',flexDirection:'row',}}>
                    
                <ListItem>
                    <ListItemIcon>
                        <ListItemButton
                        onClick={handleNext} disabled={activeStep === maxSteps - 1}
                        >
                        <ArrowCircleLeftOutlinedIcon sx={{color:'#2f6df6'}} />
                        </ListItemButton>
                        <ListItemButton onClick={handleBack} disabled={activeStep === 0}>
                        <ArrowCircleRightOutlinedIcon sx={{color:'#2f6df6'}} />
                        </ListItemButton>
                    </ListItemIcon>
                </ListItem>
                <ListItem>
                        <ListItemIcon>
                        <MobileStepper
                            steps={maxSteps}
                            position="static"
                            activeStep={activeStep}
                            sx={{background:'transparent'}}
                        />
                        </ListItemIcon>
                    </ListItem>
                </List>
            </Box>
            </Grid>
         </Grid>
        
        <Box>
            
            <Box>
        
        </Box>
        </Box>
        
        </SliderComponent>
    );
};

export default ReviewSlider1;